import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe2 } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Spinner, vibrantTheme } from "../components/common";
import { AirportCard } from "../components/PopularAirports";

export default function GlobalAirportRanking() {
  const [data, setData] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/airports-popular/global-ranking").then((r) => setData(r.data)).catch(() => setData(false));
  }, []);

  const theme = vibrantTheme("global-airport-ranking");
  const intlTheme = vibrantTheme("intl-airport-ranking");

  return (
    <div data-testid="global-airport-ranking-page">
      <PageHeader eyebrow="Global Ranking" title="World's Busiest Airports"
        subtitle="The global Top 50 by total annual passengers (ACI World), plus the Top 10 by international traffic — two very different lists." />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pb-14">
        <Link to="/airports" data-testid="back-to-airports-link"
          className="inline-flex items-center gap-1.5 text-sm font-700 text-primary hover:underline mb-5">
          <Globe2 className="w-4 h-4" /> Back to Popular Airports
        </Link>
        {data === null ? <Spinner /> : data === false ? <p className="text-muted-foreground py-10">Could not load the ranking.</p> : (
          <>
            <h2 className="font-heading font-900 text-2xl mb-4">Top {data.items.length} by Total Passengers</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-10">
              {data.items.map((a) => <AirportCard key={a.iata} a={a} accent={theme.bg} />)}
            </div>
            <h2 className="font-heading font-900 text-2xl mb-1">Top 10 by International Passengers</h2>
            <p className="text-base text-zinc-600 mb-4">Atlanta leads on total traffic — but Dubai is the world's #1 international gateway.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {data.international.map((a) => <AirportCard key={`intl-${a.iata}`} a={a} accent={intlTheme.bg} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
